import { Text } from "@mantine/core";
import { IconListCheck } from "@tabler/icons-react";
import ExpandableText from "components/ExpandableText";
import IconItem from "components/IconItem";
import React from "react";

const ShipmentInstructions: React.FC<{
  instruction: string | null;
  isDone?: boolean;
  size?: "xs" | "sm" | "md";
  openInstructions?: boolean;
  annotation?: string;
  icon?: React.ReactElement;
}> = ({
  instruction,
  isDone,
  size = "sm",
  openInstructions = false,
  annotation,
  icon,
}) => {
  if (!instruction) return <div></div>;

  const resolvedIcon = icon ?? (
    <IconListCheck
      size={size === "xs" ? 20 : undefined}
      className={isDone ? "text-gray" : "text-red-dark"}
    />
  );

  return (
    <IconItem contentAs="div" isShow={Boolean(instruction)} icon={resolvedIcon}>
      {annotation && (
        <Text fz="xs" lh={1} c="gray" mb={2}>
          {annotation}
        </Text>
      )}
      <ExpandableText
        text={instruction}
        size={size}
        openByDefault={openInstructions}
        className={isDone ? "text-gray!" : undefined}
      />
    </IconItem>
  );
};

export default ShipmentInstructions;
